/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const ActionsIcon = ({ width = 24, height = 24, hidden = false, title = 'Actions' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="m25.535 21.338-3.208 3.211 8.785 8.784a1.363 1.363 0 0 0 1.929 0l1.28-1.28a1.363 1.363 0 0 0 0-1.929ZM6.658 19.531l1.452-1.452c.533-.533-.022-1.288-.022-1.288l1.492-1.438a1.363 1.363 0 0 0 1.92-.013l.811-.811 1.562 1.561 3.209-3.209-1.565-1.561.528-.529a1.363 1.363 0 0 0 0-1.929l-.64-.64s1.885-2.116 2.28-2.512c1.665-1.664 5.351-.591 5.521-1.443s-8.183-4.012-12.757.561L5.69 9.588a1.363 1.363 0 0 0 0 1.932l.322.31L4.6 13.3a.907.907 0 0 0-1.3-.035l-1.456 1.452a.682.682 0 0 0 0 .964l3.849 3.85a.681.681 0 0 0 .965 0ZM11.041 30.523c-1.574.566-3.541 1.277-4.9 1.763l1.754-4.9Zm18.2-26.366-22.38 22.38a1.127 1.127 0 0 0-.264.413l-2.124 5.864a.84.84 0 0 0 1.1 1.109l5.894-2.1a1.127 1.127 0 0 0 .42-.267l22.375-22.4a.957.957 0 0 0 .087-1.346l-3.764-3.744a.957.957 0 0 0-1.344.091Z"
    />
  </svg>`;
};
